import { getOptionalAndCannedAttendeesQuestions } from '../../../containers/checkout/utils';
import {
    AttendeeSurvey,
    shouldIncludeInAttendeeQuestions,
} from '../../../models/survey';
import { getAttendees } from '../../../selectors/order/typedOrderSelectors';
import { CheckoutState } from '../../../state';
import { getQuestionsCollection } from '../pureSelectors';
import { buildAttendeeSurveys } from './buildAttendeeSurveys';

/**
 * @private Do not use this directly, derive information from `getSurvey` instead
 */
export const getCannedAndOptionalQuestionsForAttendees = (
    state: CheckoutState,
): Array<AttendeeSurvey> => {
    const attendees = getAttendees(state);
    const questionsCollection = getQuestionsCollection(state);
    const attendeeSurvey = buildAttendeeSurveys(
        attendees,
        questionsCollection,
        shouldIncludeInAttendeeQuestions,
    );
    return getOptionalAndCannedAttendeesQuestions(attendeeSurvey);
};
